/**
 * The 32 official Mexican federal entities, using the exact names published by
 * SEPOMEX (Correos de México). These mirror the backend `MexicanStates.All`
 * constant and the `state` values in the postal-code seed, so frontend
 * validation, the state dropdown, and CP lookups all stay in sync.
 */
export const MEXICAN_STATES = [
  "Aguascalientes",
  "Baja California",
  "Baja California Sur",
  "Campeche",
  "Chiapas",
  "Chihuahua",
  "Ciudad de México",
  "Coahuila de Zaragoza",
  "Colima",
  "Durango",
  "Guanajuato",
  "Guerrero",
  "Hidalgo",
  "Jalisco",
  "México",
  "Michoacán de Ocampo",
  "Morelos",
  "Nayarit",
  "Nuevo León",
  "Oaxaca",
  "Puebla",
  "Querétaro",
  "Quintana Roo",
  "San Luis Potosí",
  "Sinaloa",
  "Sonora",
  "Tabasco",
  "Tamaulipas",
  "Tlaxcala",
  "Veracruz de Ignacio de la Llave",
  "Yucatán",
  "Zacatecas",
] as const

export type MexicanState = (typeof MEXICAN_STATES)[number]

const stateSet = new Set<string>(MEXICAN_STATES)

export const isMexicanState = (value: string): value is MexicanState => stateSet.has(value)
